import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <img src="/logo.png" alt="Logo" className="footer-logo" />
        </div>

        <div className="footer-section">
          <h4>Navegação</h4>
          <Link to="/">Home</Link>
          <Link to="/imoveis">Buscar Imóvel</Link>
        </div>

        <div className="footer-section">
          <h4>Contato</h4>
          <p><FaPhone /> (31) 99650-6441</p>
          <p><FaEnvelope /> laremfocoimoveis@gmail.com</p>
          <p><FaMapMarkerAlt /> Santa Luzia - MG</p>
        </div>
 
        <div className="footer-section">
          <h4>Informações</h4>
          <p>CRECI: PF22109</p>
          <p>Josandru&copy; 2025</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

